import './AnalystCard.css'

const ANALYSTS = {
  'haiku': { name: 'HAIKU', role: 'Sentiment', icon: '🐦', color: '#2aa198', description: 'Social sentiment, retail vs institutional' },
  'grok': { name: 'GROK', role: 'Contrarian', icon: '⚡', color: '#d33682', description: 'Challenges consensus, finds holes' },
  'sonnet': { name: 'SONNET', role: 'Deep Research', icon: '🎵', color: '#268bd2', description: 'Filings, patents, hiring patterns' },
  'gemini': { name: 'GEMINI', role: 'Technical', icon: '♊', color: '#6c71c4', description: 'Charts, patterns, price action' },
  'llama': { name: 'LLAMA', role: 'Macro', icon: '🦙', color: '#cb4b16', description: 'Fed policy, economic indicators' },
  'opus': { name: 'OPUS', role: 'The Judge', icon: '⚖️', color: '#d4af37', description: 'Synthesizes all positions' },
  'bear': { name: 'BEAR', role: 'Risk Analyst', icon: '🐻', color: '#dc322f', description: 'Worst case scenarios, downside' },
  'bull': { name: 'BULL', role: 'Optimist', icon: '🐂', color: '#859900', description: 'Growth catalysts, upside potential' },
}

export default function AnalystCard({ analystId, selected, onToggle, disabled }) {
  const analyst = ANALYSTS[analystId]
  if (!analyst) return null

  return (
    <div
      className={`analyst-card ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={() => !disabled && onToggle(analystId)}
      style={{ '--accent': analyst.color }}
    >
      <div className="analyst-icon">{analyst.icon}</div>
      <div className="analyst-info">
        <div className="analyst-name">{analyst.name}</div>
        <div className="analyst-role">{analyst.role}</div>
        <div className="analyst-desc">{analyst.description}</div>
      </div>
      {selected && (
        <div className="analyst-check">✓</div>
      )}
    </div>
  )
}

export { ANALYSTS }
